// extracted by mini-css-extract-plugin
module.exports = {"overlay":"_3TpJl","content":"_2CC4I","fontIncrease":"_2m6HF","displayProp":"_3SS_v"};